export class DuplicateSlotUploadError extends Error {
  constructor() {
    super('Dieser Foto-Slot wird bereits hochgeladen.');
    this.name = 'DuplicateSlotUploadError';
  }
}

/** Verhindert parallele Uploads fuer denselben Slot, ohne andere Slots global zu sperren. */
export function createSlotUploadGuard() {
  const active = new Set<string>();

  return {
    async run<T>(itemId: string, upload: () => Promise<T>): Promise<T> {
      if (active.has(itemId)) throw new DuplicateSlotUploadError();
      active.add(itemId);
      try {
        return await upload();
      } finally {
        active.delete(itemId);
      }
    },
  };
}
